// Web Push — abonnement côté front
// Nécessite la clé VAPID publique dans REACT_APP_VAPID_PUBLIC_KEY
import { post } from './fetcher';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
};

export const subscribeToPush = async () => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        throw new Error("Notifications non supportées sur cet appareil");
    }
    if (!VAPID_PUBLIC_KEY) {
        throw new Error("Clé VAPID manquante (REACT_APP_VAPID_PUBLIC_KEY)");
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
        throw new Error("Permission refusée");
    }

    const registration = await navigator.serviceWorker.ready;

    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
        subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
        });
    }

    const ok = await post('/notif/subscribe', { subscription });
    if (!ok) throw new Error("Enregistrement backend échoué");

    return subscription;
};
